import TransitionToAdult from './TransitionToAdult';

export default TransitionToAdult;
